import React, { useState, useRef, useEffect } from 'react'
import { GatsbyImage } from "gatsby-plugin-image";
import Formsy from 'formsy-react';
import axios from "axios"

import FormsyInput from "./../Formsy/formsyInput"
import FormsyTextArea from "./../Formsy/FormsyTextArea"

import "./ContactForm.css";


function ContactForm(props) {
    const data = props;

    console.log(data)

    const formRef = useRef(null);


    const [canSubmit, setCanSubmit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [emailFailed, setEmailFailed] = useState(false);
    const [emailResponse, setEmailResponse] = useState("");
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [showErrorCheckbox, setShowErrorCheckbox] = useState(false);
    const [hasGdpr, setHasGdpr] = useState(false)

    useEffect(() => {
        if (canSubmit) {
            setShowErrorMessage(false)
        }
    }, [canSubmit])

    useEffect(() => {
        if (props.endPoint === "contactEmail") {
            setHasGdpr(true);
        }
    }, [])


    function disableButton() {
        setCanSubmit(false);
    }

    function enableButton() {
        setCanSubmit(true);
    }

    function submit(model) {
        setLoading(true)

        let type = "";

        if (model.fullName) {
            let payload = {
                ...model,
                language: props.language,
            }

            axios.post(`https://admin.plusmedical.gr/wp-json/myplugin/v1/websiteContactEmail`, payload)
                .then(function (response) {
                    // handle success
                    setEmailFailed(false)
                    setLoading(false)
                    setEmailSent(true)
                    setEmailResponse(response.data)

                })
                .catch(function (error) {
                    // handle error
                    setLoading(false)
                    setEmailFailed(true)
                    setEmailResponse(data.responses.failed)
                })
        }
    }

    function test(e) {
        e.preventDefault();
        console.log(e)
        if (!hasGdpr) {
            setShowErrorCheckbox(true)
        } else {
            setShowErrorMessage(true)
        }

    }

    return (
        <div className={`${emailSent ? "cf-container" : "cf-container "} px-4 py-12 md:px-0`}>
            <div className={`m-auto ${emailSent ? "max-w-none px-8 " : "max-w-xl px-4 "}relative`} >
                {loading && (
                    <div className="loader-container">
                        <div className="loader">Loading...</div>
                    </div>
                )}

                {emailFailed && (
                    <p style={{ color: "#b70000", fontSize: "1.2rem" }}>{emailResponse}</p>
                )}

                {!emailSent
                    ?
                    <Formsy
                        onValidSubmit={submit}
                        onValid={enableButton}
                        onInvalid={disableButton}
                        className={loading ? "opacity-25" : "opacity-100"}
                        ref={formRef}
                    >
                        <div>
                            <p className="text-md" style={{color: "#244989", fontSize: "14px", letterSpacing: "2px"}}>
                                {data.form.subTitle}
                            </p>
                        </div>
                        <h2 className="text-4xl">
                            {data.form.title}
                        </h2>
        
                        <div className="mt-12">

                            <div className="flex flex-wrap">
                                <FormsyInput
                                    name="fullName"
                                    placeholder={data.form.fullName}
                                    classes="mt-4 w-1/2 pr-4"
                                    required
                                />
                                <FormsyInput
                                    name="email"
                                    validations={"isEmail"}
                                    validationErrors={{
                                        isEmail: data.form.email.errorMessage,
                                    }}
                                    placeholder={data.form.email.label}
                                    classes="mt-4 w-1/2 pl-4"
                                    required
                                />
                            </div>
                            <div className="flex flex-wrap">
                                <FormsyInput
                                    name="telephone"
                                    validations={"minLength:10"}
                                    type="number"
                                    validationErrors={{
                                        minLength: data.form.telephone.errorMessage,
                                    }}
                                    placeholder={`${data.form.telephone.label} ${data.teleRequired ? "*" : ""}`}
                                    classes="mt-4 w-1/2 pr-4"
                                    required={data.teleRequired ? true : false}
                                />

                                <FormsyInput
                                    name="subject"
                                    placeholder={data.form.subject}
                                    classes="mt-4 w-1/2 pl-4"
                                    defaultValue={data.subject}
                                    required
                                />
                            </div>


                            <FormsyTextArea
                                name="message"
                                validations={"minLength: 9"}
                                validationErrors={{
                                    minLength: data.form.message.errorMessage,
                                }}
                                placeholder={data.form.message.label}
                                classes="mt-4"
                                required
                            />

                        </div>

                        <button className={"home-intro-bttn mt-8"}>
                            {data.form.sendButton}
                        </button>

                        {showErrorMessage && (
                            <p className="text-center mt-8" style={{ color: "#b70000", fontSize: "1.2rem", }}>Συμπληρώστε όλα τα απαραίτητα πεδία (*)</p>
                        )}
                        {showErrorCheckbox && (
                            <p className="text-center mt-8" style={{ color: "#b70000", fontSize: "1.2rem", }}>Παρακαλoύμε αποδεχτείτε τους όρους χρήσης</p>
                        )}
                    </Formsy>
                    :
                    <div >
                        <div className="email-response" dangerouslySetInnerHTML={{ __html: emailResponse }} />
                    </div>
                }

            </div>
        </div>
    )
}

export default ContactForm;